export default "__VITE_ASSET__G3F2rHmN__"